import { FormControl, Select } from '@chakra-ui/react';
import { Branch } from '@texas/api/endpoints/branchesApi';
import { SearchFilterInput } from '@texas/components/SearchFilterInput';
import { TexasSwitch } from '@texas/components/shared/form/TexasSwitch';
import { useTranslation } from 'react-i18next';

interface Props {
  branches: Branch[];
  filter: string;
  branchId: number;
  includeArchived: boolean;
  onFilterChange: (value: string) => void;
  onBranchChange: (value: number) => void;
  onIncludeArchivedChange: (value: boolean) => void;
}

export function CustomsCodeFilters({
  branches,
  filter,
  branchId,
  includeArchived,
  onFilterChange,
  onBranchChange,
  onIncludeArchivedChange,
}: Props) {
  const { t } = useTranslation();
  return (
    <>
      <FormControl w="240px">
        <Select
          aria-label={t('general.branch')}
          variant="entityDirectory"
          h="44px"
          value={branchId}
          onChange={(event) => onBranchChange(Number(event.target.value))}
        >
          <option value={0}>{t('filter.allBranches')}</option>
          {branches.map((branch) => (
            <option key={branch.id} value={branch.id}>
              {branch.name}
            </option>
          ))}
        </Select>
      </FormControl>
      <SearchFilterInput
        value={filter}
        style="entityDirectory"
        onChange={onFilterChange}
      />
      <TexasSwitch
        checked={includeArchived}
        label={t('general.includeArchived')}
        onChange={onIncludeArchivedChange}
      />
    </>
  );
}
